import React, { useEffect, useState } from 'react'
import { config } from '../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonAxiosGet } from '../../CommonUtilities/CommonAxios/CommonAxios';
import { AbstractColumns } from '../../CommonUtilities/CommonReactColumn/Commoncolumns';
import CommonReportComponent from '../../CommonUtilities/CommonReactColumn/CommonReportComponent';
export default function DistwiseCandidatesReport() {
    const [showDistwiseCandidateData, setDistwiseCandidateData] = useState([]);
    const [showDistrictName, setDistrictName] = useState('');
    const [showCasteName, setCasteName] = useState('');
    const [showDistrictAbstractData, setDistrictAbstractData] = useState([])
    const [showDrillCount, setDrillCount] = useState();
    const createColumn = (distheader, distaccessor, distValue, casteValue = '') => (
        { Header: distheader, distaccessor,
        Cell: ({ row }) => (
          <button className='btn btn-link'
            style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue', textAlign: 'right' }}
            onClick={() => {
              getDistwiseAbstractData(row?.original?.dist_code, distValue);
              setDistrictName(row?.original?.dist_name);
              setCasteName(casteValue ? `- ${casteValue}` : "");
              setDrillCount(1);}}>
            {row?.original?.[distaccessor]}
          </button>
        ),
        Footer: distaccessor,
        FooterFunc: () => {
          getDistwiseAbstractData("0", distValue);
          setDrillCount(1);
          setDistrictName('');
          setCasteName(casteValue);
        },
       isClickable: true,});     
       const distcolumns = [
        { Header: "S.NO", accessor: (row, index) => index + 1, Footer: "Total" },
        { Header: () => "District Name", accessor: "dist_name" },
        createColumn("Total", "tot_appl", "T","Total"),
     
        {  Header: "Caste Wise",
            columns: [
                createColumn("OC", "oc", "OC", "OC"),
                createColumn("BC-A", "bc_a", "BC-A", "BC-A"),
                createColumn("BC-B", "bc_b", "BC-B", "BC-B"),
                createColumn("BC-C", "bc_c", "BC-C", "BC-C"),
                createColumn("BC-D", "bc_d", "BC-D", "BC-D"),
                createColumn("BC-E", "bc_e", "BC-E", "BC-E"),
                createColumn("SC-GR I", "sc_gr_i", "SC-GR I", "SC-GR I"),
                createColumn("SC-GR II", "sc_gr_ii", "SC-GR II", "SC-GR II"),
                createColumn("SC-GR III", "sc_gr_iii", "SC-GR III", "SC-GR III"),
                createColumn("ST", "st", "ST", "ST"),
            ]
        },
        createColumn("EWS", "ews", "EWS", "EWS"),
        {Header: "PH Wise",
            columns: [
                createColumn("VH", "vh", "VH", "VH"),
                createColumn("HH", "hi", "HI", "HH"),
                createColumn("OH", "oh", "OH", "OH"),
                createColumn("MI", "mi", "MI", "MI"),
            ]
        },]
    function getDistwisedata() {
        let Url = config.url.CONTEXT_READ_URL + "dist-wise-candidates"
        CommonAxiosGet(Url).then((res) => {
            if (res?.data?.status === true && res?.data?.scode === "01") {
                setDrillCount(0); setDistwiseCandidateData(res?.data?.data); }
            else { setDistwiseCandidateData([]) }
        })}
    function getDistwiseAbstractData(distcode, castecode) {
        let Url = config.url.CONTEXT_READ_URL + "dist-wise-candidates/drill?distCode=" + distcode + "&caste=" + castecode
        CommonAxiosGet(Url).then((res) => {
            if (res?.data?.status === true && res?.data?.scode === "01") {
                setDistrictAbstractData(res?.data?.data); setDrillCount(1) }
            else { setDistrictAbstractData([]) }
        })}
    useEffect(() => { getDistwisedata(); }, []);
    function isBackFunction() { setDrillCount(showDrillCount - 1) }
    return (<div>
<CommonReportComponent
  showDrillCount={showDrillCount}
  showData={showDistwiseCandidateData}
  showAbstractData={showDistrictAbstractData}
  columns={distcolumns}
  AbstractColumns={AbstractColumns}
  level0Heading="District Wise Candidates Details"
  level1Heading={`${showDistrictName} ${showCasteName} Candidates Details`}
  headerNameLevel0={<>District Wise Candidates Details</>}
  headerNameLevel1={<>{`${showDistrictName} ${showCasteName} Candidates Details`}</>}
  isBackFunction={isBackFunction}
/> 
</div> )}
